import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdministratorAutomatedReports = () => {
  const [emailsReport, setEmailsReport] = useState([]);
  const [companyEmails, setCompanyEmails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [emailsLoading, setEmailsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [emailsError, setEmailsError] = useState(null);
  const [emailsCurrentPage, setEmailsCurrentPage] = useState(1);
  const [emailsLastPage, setEmailsLastPage] = useState(1);

  const fetchReports = () => {
    setLoading(true);
    setError(null);

    axios.get('/api/administrator/automated-reports/emails')
      .then((response) => {
        setEmailsReport(response.data.emails || []);
      })
      .catch(() => {
        setError('No se pudo cargar el reporte de emails.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchCompanyEmails = (page = 1) => {
    setEmailsLoading(true);
    setEmailsError(null);

    axios.get('/api/administrator/automated-reports/paying-company-emails', {
      params: { page },
    })
      .then((response) => {
        const data = response.data;
        setCompanyEmails(data.data || []);
        setEmailsCurrentPage(data.current_page || 1);
        setEmailsLastPage(data.last_page || 1);
      })
      .catch(() => {
        setEmailsError('No se pudo cargar el reporte de emails.');
      })
      .finally(() => {
        setEmailsLoading(false);
      });
  };

  useEffect(() => {
    fetchReports();
    fetchCompanyEmails(1);
  }, []);

  return (
    <div className="mt-4">
      <h3>Reportes automatizados</h3>

      {loading && <div>Cargando...</div>}
      {error && <div className="alert alert-danger">{error}</div>}

      {!loading && !error && (
        <>
          <div className="card mb-4">
            <div className="card-body">
              <h4 className="mb-3">Empresas que pagan</h4>
              <p className="text-muted">Razones sociales de empresas marcadas como pagadoras</p>

              {emailsReport.length === 0 ? (
                <div className="alert alert-light mb-0">No hay empresas marcadas como pagadoras.</div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>Razón social</th>
                        <th>RFC</th>
                      </tr>
                    </thead>
                    <tbody>
                      {emailsReport.map((company) => (
                        <tr key={company.id}>
                          <td>{company.fiscal_name}</td>
                          <td>{company.rfc}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

          <div className="card mb-4">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div>
                  <h4 className="mb-1">Emails</h4>
                  <p className="text-muted mb-0">Emails de empresas que pagan y de sus providers/completadores relacionados</p>
                </div>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => window.location.href = '/api/administrator/automated-reports/paying-company-emails/export'}
                >
                  Exportar Excel
                </button>
              </div>

              {emailsLoading && <div>Cargando emails...</div>}
              {emailsError && <div className="alert alert-danger">{emailsError}</div>}

              {!emailsLoading && !emailsError && companyEmails.length === 0 ? (
                <div className="alert alert-light mb-0">No se encontraron emails para empresas pagadoras.</div>
              ) : (
                !emailsLoading && !emailsError && (
                  <>
                    <div className="table-responsive">
                      <table className="table table-striped table-bordered mb-0">
                        <thead>
                          <tr>
                            <th>Empresa</th>
                            <th>RFC</th>
                            <th>Email</th>
                            <th>Origen</th>
                          </tr>
                        </thead>
                        <tbody>
                          {companyEmails.map((row, index) => (
                            <tr key={`${row.company_id}-${row.email}-${row.source}-${index}`}>
                              <td>{row.company_name}</td>
                              <td>{row.company_rfc}</td>
                              <td>{row.email}</td>
                              <td>{row.source === 'empresa' ? 'Empresa' : 'Provider / Completador'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {emailsLastPage > 1 && (
                      <nav className="mt-4">
                        <ul className="pagination">
                          <li className={`page-item ${emailsCurrentPage === 1 ? 'disabled' : ''}`}>
                            <button
                              type="button"
                              className="page-link"
                              onClick={() => fetchCompanyEmails(emailsCurrentPage - 1)}
                            >
                              Anterior
                            </button>
                          </li>
                          <li className="page-item disabled">
                            <span className="page-link">
                              Página {emailsCurrentPage} de {emailsLastPage}
                            </span>
                          </li>
                          <li className={`page-item ${emailsCurrentPage === emailsLastPage ? 'disabled' : ''}`}>
                            <button
                              type="button"
                              className="page-link"
                              onClick={() => fetchCompanyEmails(emailsCurrentPage + 1)}
                            >
                              Siguiente
                            </button>
                          </li>
                        </ul>
                      </nav>
                    )}
                  </>
                )
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdministratorAutomatedReports;
